<template>
		<v-card :flat="clinic">
			<v-card-title v-if="!clinic" class="title primary--text secondary" v-translate>Vital Signs Test</v-card-title>
			<v-card-text>
				<v-form ref="form" v-model="valid">
					<v-container class="pb-0">
						<v-row no-gutters>
							<v-col cols="12" sm="6" class="text-center">
								<strong>Dados Cardiorespiratórios</strong>
								<v-row no-gutters class="my-3">
									<v-col cols="12" sm="6">
										<v-text-field
											v-model="test.tensao_sistolica"
											label="T. Sistólica"
											class="px-2"
											outlined
											:disabled="results"
										/>
									</v-col>
									<v-col cols="12" sm="6">
										<v-text-field
											v-model="test.tensao_diastolica"
											label="T. Diastólica"
											class="px-2"
											outlined
											:disabled="results"
										/>
									</v-col>
									<v-col cols="12" sm="6">
										<v-text-field
											v-model="test.ritmo_cardiaco"
											label="Ritmo Cardíaco"
											class="px-2"
											outlined
											:disabled="results"
										/>
									</v-col>
									<v-col cols="12" sm="6">
										<v-text-field
											v-model="test.oximetria"
											label="Oximetria"
											class="px-2"
											outlined
											:disabled="results"
										/>
									</v-col>
								</v-row>
							</v-col>
							<v-col cols="12" sm="6" class="text-center">
								<strong>Dados Antropométricos</strong>
								<v-row no-gutters class="my-3">
									<v-col cols="12" sm="6">
										<v-text-field v-model="test.peso" label="Peso" class="px-2" outlined :disabled="results" />
									</v-col>
									<v-col cols="12" sm="6">
										<v-text-field
											v-model="test.altura"
											label="Altura"
											class="px-2"
											outlined
											:disabled="results"
										/>
									</v-col>
									<v-col cols="12" sm="6">
										<v-text-field v-model="test.imc" label="IMC" class="px-2" outlined :disabled="results" />
									</v-col>
									<v-col cols="12" sm="6">
										<v-text-field
											v-model="test.perimetro_abdominal"
											label="P. Abdominal"
											class="px-2"
											outlined
											:disabled="results"
										/>
									</v-col>
								</v-row>
							</v-col>
							<v-col cols="12" sm="6" class="text-center">
								<strong>Dados Metabólicos</strong>
								<v-row no-gutters class="mt-3">
									<v-col cols="12" sm="6">
										<v-text-field
											v-model="test.ph_saliva"
											label="pH Saliva"
											class="px-2"
											outlined
											:disabled="results"
										/>
									</v-col>
									<v-col cols="12" sm="6">
										<v-text-field
											v-model="test.ph_urina"
											label="pH Urina"
											class="px-2"
											outlined
											:disabled="results"
										/>
									</v-col>
									<v-col cols="12" sm="6">
										<v-text-field
											v-model="test.glicemia"
											label="Glicémia"
											class="px-2"
											outlined
											:disabled="results"
										/>
									</v-col>
									<v-col cols="12" sm="6">
										<v-text-field
											v-model="test.ureia_creatinina"
											label="Ureia/Creatinina"
											class="px-2"
											outlined
											:disabled="results"
										/>
									</v-col>
								</v-row>
							</v-col>
							<v-col cols="12" sm="6" class="text-center">
								<strong>Temperatura Corporal</strong>
								<v-row no-gutters class="mt-3">
									<v-col cols="12" sm="6">
										<v-text-field
											v-model="test.temperatura_axilar"
											label="Axilar"
											class="px-2"
											outlined
											:disabled="results"
										/>
									</v-col>
									<v-col cols="12" sm="6">
										<v-text-field
											v-model="test.temperatura_oral"
											label="Oral"
											class="px-2"
											outlined
											:disabled="results"
										/>
									</v-col>
									<v-col cols="12" sm="6">
										<v-text-field
											v-model="test.temperatura_anal"
											label="Anal"
											class="px-2"
											outlined
											:disabled="results"
										/>
									</v-col>
									<v-col cols="12" sm="6">
										<v-text-field
											v-model="test.temperatura_testa"
											label="Testa"
											class="px-2"
											outlined
											:disabled="results"
										/>
									</v-col>
								</v-row>
							</v-col>
							<!-- <v-col cols="12" md="12">
              <v-btn color="primary" class="float-right" @click="submitTest">Submit</v-btn>
							</v-col>-->
						</v-row>
					</v-container>
				</v-form>
			</v-card-text>
			<v-divider v-if="!clinic"></v-divider>
			<v-card-actions v-if="!clinic">
				<v-btn v-if="results" color="primary darken-1" text @click="hide">
					<translate>Close</translate>
				</v-btn>
				<v-btn v-else color="primary darken-1" text @click="hide">
					<translate>Cancel</translate>
				</v-btn>
				<v-spacer></v-spacer>
				<v-btn v-if="!edit && !results" color="primary darken-1" text @click="submitTest">
					<translate>Create</translate>
				</v-btn>
				<v-btn v-if="edit" color="primary darken-1" text @click="editTest">
					<translate>Save</translate>
				</v-btn>
			</v-card-actions>
		</v-card>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: "VitalSignsForm",
	props: {
		test: {
			default: () => ({
				kind: "exam",
				module: "general",
				tensao_sistolica: "",
				tensao_diastolica: "",
				ritmo_cardiaco: "",
				oximetria: "",
				peso: "",
				altura: "",
				imc: "",
				perimetro_abdominal: "",
				ph_saliva: "",
				ph_urina: "",
				glicemia: "",
				ureia_creatinina: "",
				temperatura_axilar: "",
				temperatura_oral: "",
				temperatura_anal: "",
				temperatura_testa: ""
			})
		},
		edit: {
			default: false
		},
		results: {
			default: false
		},
		clinic: {
			default: false
		}
	},
	data: () => ({
		valid: false
	}),
	methods: {
		submitTest() {
			const formData = new FormData();
			formData.append("tensao_sistolica", this.test.tensao_sistolica);
			formData.append("tensao_diastolica", this.test.tensao_diastolica);
			formData.append("ritmo_cardiaco", this.test.ritmo_cardiaco);
			formData.append("oximetria", this.test.oximetria);
			formData.append("peso", this.test.peso);
			formData.append("altura", this.test.altura);
			formData.append("imc", this.test.imc);
			formData.append("perimetro_abdominal", this.test.perimetro_abdominal);
			formData.append("ph_saliva", this.test.ph_saliva);
			formData.append("ph_urina", this.test.ph_urina);
			formData.append("glicemia", this.test.glicemia);
			formData.append("ureia_creatinina", this.test.ureia_creatinina);
			formData.append("temperatura_axilar", this.test.temperatura_axilar);
			formData.append("temperatura_oral", this.test.temperatura_oral);
			formData.append("temperatura_anal", this.test.temperatura_anal);
			formData.append("temperatura_testa", this.test.temperatura_testa);
			formData.append("kind", "exam");
			formData.append("module", "general");
			this.$emit("create-test", formData);
			this.hide();
		},
		editTest() {
			const formData = new FormData();
			formData.append("tensao_sistolica", this.test.tensao_sistolica);
			formData.append("tensao_diastolica", this.test.tensao_diastolica);
			formData.append("ritmo_cardiaco", this.test.ritmo_cardiaco);
			formData.append("oximetria", this.test.oximetria);
			formData.append("peso", this.test.peso);
			formData.append("altura", this.test.altura);
			formData.append("imc", this.test.imc);
			formData.append("perimetro_abdominal", this.test.perimetro_abdominal);
			formData.append("ph_saliva", this.test.ph_saliva);
			formData.append("ph_urina", this.test.ph_urina);
			formData.append("glicemia", this.test.glicemia);
			formData.append("ureia_creatinina", this.test.ureia_creatinina);
			formData.append("temperatura_axilar", this.test.temperatura_axilar);
			formData.append("temperatura_oral", this.test.temperatura_oral);
			formData.append("temperatura_anal", this.test.temperatura_anal);
			formData.append("temperatura_testa", this.test.temperatura_testa);
			formData.append("kind", "exam");
			formData.append("module", "general");
			this.$emit("edit-test", formData);
			this.hide();
		},
		hide() {
			this.$emit("hide");
		}
	},
	computed: {
		...mapGetters({
      tourStep: 'tourStepEvent'
    })
	},
	watch: {
		tourStep(value) {
			if(value == 'tour-test-vital-signs-submit') {
				this.test.tensao_sistolica = 120;
				this.test.tensao_diastolica = 80;
				this.test.ritmo_cardiaco = 70;
				this.test.oximetria = 95;
				this.test.peso = 75;
				this.test.altura = 180;
				this.test.imc = 23;
				this.test.perimetro_abdominal = 90;
				this.test.ph_saliva = 7;
				this.test.ph_urina = 8;
				this.test.glicemia = 90;
				this.test.ureia_creatinina = 31;
				this.test.temperatura_axilar = 37;
				this.test.temperatura_oral = 36;
				this.test.temperatura_anal = 37;
				this.test.temperatura_testa = 37;
				this.submitTest();
			}
		}
	}
};
</script>